import { render, staticRenderFns } from "./Q90.vue?vue&type=template&id=b36a4a10&"
import script from "./Q90.vue?vue&type=script&lang=js&"
export * from "./Q90.vue?vue&type=script&lang=js&"
import style0 from "./Q90.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports